<template>
  <!-- div class="leftbox">
    <div class="imgContainer" -->
      <div>
      <img class="centerLeft" :src="getTrialCue" />
      <img class="center" src="../assets/optimal_fixation.png"/>
    </div>
    <!-- /div>  
    
  </div -->
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import * as Mousetrap from 'mousetrap'
import * as _ from 'lodash'
import State from '../mixins/State'
export default {
  mixins: [ State ],
  data: () => {
    return {
      timer: undefined,
      keyCode: undefined,
      start_time: undefined,
      response_time: null,
      end_time: undefined
    }
  },
  computed: {
    ...mapGetters(['getTrialCue']),
    ...mapState({
      cue_duration: state => state.parameters.cue_duration
    })
  },
  mounted () {
    this.setStartTime() // intertrial start time
    this.start_time = Date.now() // component start time

    // binds a handler to the left and right keys
    Mousetrap.bind(['left'], _.once((e) => {
      // record the response and reaction time in ms
      this.keyCode = e.keyCode
      this.response_time = Date.now() - this.start_time
      this.$router.push({ name: 'Focus', params: { page: 'cue' } })
      // console.log(this.$router)
    }))

    // create a timer to navigate to the outcome state
    this.timer = setTimeout(() => {
      this.$router.push('/focus/cue')
      // this.$router.push({ name: 'Focus', params: { page: 'cue' } })
    }, this.cue_duration)
  },
  beforeDestroy () {
    // clear the timer when the cue state is left
    clearTimeout(this.timer)
    Mousetrap.unbind(['left'])
    this.end_time = Date.now()
    const remainingTime = this.response_time === null ? 0 : (this.cue_duration - this.response_time)
    this.response({ r: this.keyCode, remaining_time: remainingTime, start_time: this.start_time, response_time: this.response_time, end_time: this.end_time, response_state: 'cue' })
  },
  methods: {
    ...mapActions(['response', 'setStartTime'])
  }
}
</script>
